/**
 * Synergies Configuration for Interactive Game
 * 4 synergies that activate when all required skills are unlocked
 */

import type { SynergyConfig } from '../types'

export const SYNERGIES_CONFIG: SynergyConfig[] = [
  {
    id: 'container-trio',
    name: 'Container Trio',
    requiredSkills: ['docker', 'kubernetes', 'github-actions'],
    bonus: { resource: 'cloud', multiplier: 0.8 },
    description: 'Docker + Kubernetes + GitHub Actions: Containerization mastery',
    icon: '🐳',
  },
  {
    id: 'cicd-powerhouse',
    name: 'CI/CD Powerhouse',
    requiredSkills: ['azure-devops', 'gitlab-ci', 'github-actions'],
    bonus: { resource: 'cicd', multiplier: 1.0 },
    description: 'Azure DevOps + GitLab CI + GitHub Actions: Multi-platform CI/CD expertise',
    icon: '⚡',
  },
  {
    id: 'data-stack',
    name: 'Data Stack',
    requiredSkills: ['python', 'sql', 'airflow', 'spark'],
    bonus: { resource: 'data', multiplier: 1.0 },
    description: 'Python + SQL + Airflow + Spark: Complete data engineering pipeline',
    icon: '📊',
  },
  {
    id: 'iac-workflow',
    name: 'IaC Workflow',
    requiredSkills: ['terraform', 'yaml', 'linux'],
    bonus: { resource: 'cloud', multiplier: 0.6 },
    description: 'Terraform + YAML + Linux: Infrastructure as Code mastery',
    icon: '🏗️',
  },
]

/**
 * Helper to get synergy by ID
 */
export function getSynergyById(id: string): SynergyConfig | undefined {
  return SYNERGIES_CONFIG.find((synergy) => synergy.id === id)
}

/**
 * Check if a synergy is active based on unlocked skills
 */
export function isSynergyActive(synergy: SynergyConfig, unlockedSkills: Set<string>): boolean {
  return synergy.requiredSkills.every((skillId) => unlockedSkills.has(skillId))
}

/**
 * Get all active synergies based on unlocked skills
 */
export function getActiveSynergies(unlockedSkills: Set<string>): SynergyConfig[] {
  return SYNERGIES_CONFIG.filter((synergy) => isSynergyActive(synergy, unlockedSkills))
}
